/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataBbsContentInfoRespVo } from './PageDataBbsContentInfoRespVo';
import {
    PageDataBbsContentInfoRespVoFromJSON,
    PageDataBbsContentInfoRespVoFromJSONTyped,
    PageDataBbsContentInfoRespVoToJSON,
    PageDataBbsContentInfoRespVoToJSONTyped,
} from './PageDataBbsContentInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataBbsContentInfoRespVo
 */
export interface ResponsePageDataBbsContentInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataBbsContentInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataBbsContentInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataBbsContentInfoRespVo}
     * @memberof ResponsePageDataBbsContentInfoRespVo
     */
    data?: PageDataBbsContentInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataBbsContentInfoRespVo interface.
 */
export function instanceOfResponsePageDataBbsContentInfoRespVo(value: object): value is ResponsePageDataBbsContentInfoRespVo {
    return true;
}

export function ResponsePageDataBbsContentInfoRespVoFromJSON(json: any): ResponsePageDataBbsContentInfoRespVo {
    return ResponsePageDataBbsContentInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataBbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataBbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataBbsContentInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataBbsContentInfoRespVoToJSON(json: any): ResponsePageDataBbsContentInfoRespVo {
    return ResponsePageDataBbsContentInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataBbsContentInfoRespVoToJSONTyped(value?: ResponsePageDataBbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataBbsContentInfoRespVoToJSON(value['data']),
    };
}

